import React from 'react';
import SMCLabel from '../../../components/Simple/SMCLabel';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import {SMCSelect, SMCOption} from '../../../components/Simple/SMCSelect';
import {RoleRuleSchema} from '../../../api/DBSchema/Role';
import {SystemRoleRuleSchema} from '../../../api/DBSchema/SystemRole';
import {useTranslation} from 'react-i18next';
import SMCButton from '../../../components/Simple/SMCButton';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import SMCTextInput from '../../../components/Simple/SMCTextInput';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import SMCIcon from '../../../components/Simple/SMCIcon';
import { makeStyles } from '@mui/styles';
import RowLayout from '../../../components/Layouts/RowLayout';

function RoleRuleEditorStepTwo({
    onCancel,
    onNext,
    onBack,
    onFinish,
    object,
    setObjectValue,
    isSystemRole
}) {
    const { t } = useTranslation();
    const classes = useStyles();

    const actions       = object[RoleRuleSchema.actions];
    const actionsValues = RoleRuleSchema.actionsValues;
    const subject       = object[RoleRuleSchema.subject];
    const subjectSchema = RoleRuleSchema.subjectSchema;

    const target        = subject[subjectSchema.target];
    const targetValues  = subjectSchema.targetValues;
    const condition     = subject[subjectSchema.condition];

    return (
        <>
        <SMCModalBody>
            <SMCLabel bold fontSize="15px">{t('SMP.ROLES.ROLE_RULE_WIZ.RULE_SUBJECT')}</SMCLabel>
            <SMCLabel>{t('SMP.ROLES.ROLE_RULE_WIZ.LINE3')}</SMCLabel>
            <SMCSelect
                value={target}
                onChange={e => setObjectValue([RoleRuleSchema.subject, subjectSchema.target], e.target.value)}
                label={t('SMP.ROLES.ROLE_RULE_WIZ.OBJECT_TYPE')}
            >
                <SMCOption value={targetValues.ANY}>*</SMCOption>
                <SMCOption value={targetValues.USER}>{t('SMP.ROLES.ROLE_RULE_WIZ.OBJECT_TYPE.USER')}</SMCOption>
                {
                    isSystemRole && (
                        <SMCOption value={SystemRoleRuleSchema.subjectSchema.targetValues.SYSTEM_USER}>{t('SMP.ROLES.ROLE_RULE_WIZ.OBJECT_TYPE.SYSTEM_USER')}</SMCOption>
                    )
                }
                <SMCOption value={targetValues.CPSMPPLAN}>{t('SMP.ROLES.ROLE_RULE_WIZ.OBJECT_TYPE.PLAN')}</SMCOption>
                <SMCOption value={targetValues.COMMUNITY}>{t('SMP.ROLES.ROLE_RULE_WIZ.OBJECT_TYPE.COMMUNITY')}</SMCOption>
                <SMCOption value={targetValues.CPSMPGATEWAY}>{t('SMP.ROLES.ROLE_RULE_WIZ.OBJECT_TYPE.GATEWAY')}</SMCOption>
                <SMCOption value={targetValues.ROLE}>
                    { isSystemRole ? t('SMP.ROLES.ROLE_RULE_WIZ.OBJECT_TYPE.SERVICE_DOMAIN_ROLE') : t('SMP.ROLES.ROLE_RULE_WIZ.OBJECT_TYPE.ROLE') }
                </SMCOption>
                <SMCOption value={targetValues.POLICY}>{t('SMP.ROLES.ROLE_RULE_WIZ.OBJECT_TYPE.POLICY')}</SMCOption>
                <SMCOption value={targetValues.CUSTOM_IMAGE}>{t('SMP.ROLES.ROLE_RULE_WIZ.OBJECT_TYPE.CUSTOM_IMAGE')}</SMCOption>
                <SMCOption value={targetValues.FIRMWARE}>{t('SMP.ROLES.ROLE_RULE_WIZ.OBJECT_TYPE.FIRMWARE')}</SMCOption>
                <SMCOption value={targetValues.PORTAL_SETTINGS}>{t('SMP.ROLES.ROLE_RULE_WIZ.OBJECT_TYPE.SERVICE_DOMAIN_SETTINGS')}</SMCOption>
            </SMCSelect>
            <SMCTextInput
                value={condition}
                onChange={e => setObjectValue([RoleRuleSchema.subject, subjectSchema.condition], e.target.value)}
                label={t('SMP.ROLES.ROLE_RULE_WIZ.CONDITION_CRITERIA')}
            />
            {
                target === SystemRoleRuleSchema.subjectSchema.targetValues.SYSTEM_USER &&
                (actions.includes(actionsValues.CREATE) || actions.includes(actionsValues.DELETE)) &&
                (
                    <RowLayout className={classes.systemUserWarning}><SMCIcon icon="warning" />Warning! System user cannot read/create/delete other system users</RowLayout>
                )
            }
        </SMCModalBody>
        <SMCModalButtonContainer>
            <SMCButton onClick={onBack}>
                <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="arrow-circle-left" />
                {t('SMC_GEN_BACK')}
            </SMCButton>
            <SMCButton onClick={onFinish}>
                <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                {t('SMC_GEN_FINISH')}
            </SMCButton>
            <SMCButton onClick={onCancel}>
                <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                {t('SMC_GEN_CANCEL')}
            </SMCButton>
        </SMCModalButtonContainer>
        </>
    )
}

const useStyles = makeStyles({
    systemUserWarning: {
        fontWeight: 'bold',
        color: 'orange'
    }
})

export default RoleRuleEditorStepTwo;